<template>
  <section>
    <form class="topup-form" @submit="submit">
      <div class="topup-form-frame">
        <h2><strong>Krok 2</strong> - Kwota doładowania</h2>
        <section class="topup-amounts-container" v-for="(topup, topupIndex) in form.topup" :key="topupIndex">
          <h1>Wybierz kwotę doładowania dla&nbsp;numeru <span>{{topup.phone}}</span></h1>

          <div>
            <ul class="topup-amounts">
              <li class="topup-amount" :class="['topup-' + amount, {active: isAmountSet(amount, topupIndex)}]" v-for="(amount, amountIndex) in TOPUP_AMOUNTS" :key="amountIndex" @click="setTopupAmount(amount, topupIndex)">
                <span>
                  <span class="topup-amount-value">{{amount}}</span> zł
                </span>
                <span class="topup-amount-recommend" v-if="isAmountRecommended(amount)">Polecane!</span>
              </li>
              <li class="topup-amount" ref="topupAmountOther" :class="{active: topup.isAmountOtherSet}" @click="enableOtherAmount(topupIndex)">
                <span v-if="!isAmountOtherSet(topupIndex)">
                  <span class="topup-amount-value-other">inna<br>kwota</span>
                </span>
                <span class="topup-amount-value-field" v-if="isAmountOtherSet(topupIndex)">
                  <input id="topup-amount-other" type="text" v-model="topup.amountOther" @change="formatAmount(topupIndex)">
                </span>
                <span v-if="isAmountOtherSet(topupIndex)" class="topup-amount-recommend">{{TOPUP_AMOUNT_MIN}}-{{TOPUP_AMOUNT_MAX}} zł</span>
              </li>
            </ul>
          </div>
        </section>
      </div>
      <div class="topup-form-buttons">
        <button id="go-back-step-2" type="button" @click="goBack">‹ Wróć</button>
        <button id="submit-step-2" type="submit" :disabled="!isFormValid()">Dalej ›</button>
      </div>
    </form>
  </section>
</template>

<script>
import TopupStage2Mixin from '../../../common/mixins/Topup/Stage2.mixin'

export default {
  name: 'TopupStage2',
  mixins: [TopupStage2Mixin]
}
</script>

<style src="../../assets/scss/topup-form.scss" lang="scss"></style>
